
export const projectDetails = [
    {
        label: "Client",
        name: "client"
    },
    {
        label: "Project No.",
        name: "projectNo"
    },
    {
        label: "Vessel",
        name: "vessel"
    }, {
        label: "Tag No.",
        name: "tagNo"
    }, {
        label: "Rev No.",
        name: "revNo"
    }
]

export const designDetails = [
    {
        label: "Design Code",
        name: "designCode",
        select: [
            { value: "ASME VII DIV 1", label: "ASME VII DIV 1" },
            { value: "ASME VII DIV 2", label: "ASME VII DIV 2" },
        ],
        required: true
    },
    {
        label: "Edition/ Addenda",
        name: "editionAddenda",
        disabled: true
    },
    {
        label: "U Stamp",
        name: "uStamp",
        select: [
            { value: "Yes", label: "Yes" },
            { value: "No", label: "No" },
        ]
    },
    {
        label: "CRN",
        name: "crn"
    },

]

export const designInputs = [
    {
        label: "Int. Pressure",
        name: "designInternalPressure",
        type: "number",
        pairField: "txt_DP_CSC",
        endAdornment: "N/mm\xB2",
        englishAdornment: "psi",
        required: true

    },
    {
        label: "Ext. Pressure ",
        name: "designExternalPressure",
        type: "number",
        required: true,
        pairField: "externalPressureCSC",
        endAdornment: "N/mm\xB2",
        englishAdornment: "psi"
    },
    {
        label: "Design Temp.",
        name: "designTemperature",
        type: "number",
        required: true,
        pairField: "txt_DT_CSC",
        endAdornment: "°C",
        englishAdornment: "°F"
    },
    {
        label: "MDMT",
        name: "mdmt",
        type: "number",
        required: true,
        endAdornment: "°C", // ° degree symbol
        englishAdornment: "°F"
    },
    {
        label: "Corr. Allow.",
        name: "corrosionAllowanceShell",
        pairField: "true",
        type: "number",
        required: true,
        endAdornment: "mm",
        englishAdornment: "in"
    },
    // {
    //     label: "CA Nozzle",
    //     name: "corrosionAllowanceNozzle",
    //     type: "number",
    //     required: true,
    //     endAdornment: "mm"
    // },
    {
        label: "Joint Eff. Long.",
        name: "jointEffLong",
        type: "number",
        pairField: "txt_JE_CSC",
        required: true,
    },
    {
        label: "Joint Eff. Circ.",
        name: "jointEffCirc",
        type: "number",
        required: true,
    },
    {
        label: "Radiography",
        name: "radiography",
        required: true,
        select: [
            { value: "", label: "Select Radiography" },
            { value: "RT1", label: "RT1" },
            { value: "RT2", label: "RT2" },
            { value: "RT3", label: "RT3" },
            { value: "RT4", label: "RT4" },
        ]
    },
    {
        label: "Wind Speed",
        name: "windSpeed",
        endAdornment: "Km/hr",
        englishAdornment: "mph"
    },
    {
        label: "Wind Design Code",
        name: "windDesignCode"
    },
    {
        label: "Seismic Zone",
        name: "seismicZone"
    },
    {
        label: "Seismic Spec",
        name: "seismicZone"
    },
    // {
    //     label: "Flange rating ",
    //     name: "flangeRating"
    // },
    // {
    //     label: "ASME B16.5",
    //     name: "asmeB165Group"
    // },
    {
        label: "Impact Test ",
        name: "impactTest",
        select: [
            { value: "YES", label: "YES" },
            { value: "NO", label: "NO" }
        ]
    }
]

export const GeometricInputs = [
    {
        label: "Orientation",
        name: "orientation",
        required: true,
        select: [
            { value: "Horizontal", label: "Horizontal" },
            { value: "Vertical", label: "Vertical" },
        ],

        // pairField: "designInternalPressure",
        // endAdornment: "N/mm	\xB2"
    },
    {
        label: "Diameter Basis ",
        name: "diameterBasis",
        select: [
            { value: "ID", label: "ID" },
            { value: "OD", label: "OD" },
        ],
        required: true

    },
    {
        label: "Vessel Diameter",
        name: "vesselDiameter",
        required: true,
        pairField: "true",
        type: "number",
        endAdornment: "mm",
        englishAdornment: "in"
    },
    {
        label: "Vessel Length T-T:",
        name: "vesselLengthTT",
        required: true,
        endAdornment: "mm",
        englishAdornment: "in",
        pairField: "txt_LS_SC"

    },
    {
        label: "Vessel Length S-S:",
        name: "vesselLengthSS",
        required: true,
        endAdornment: "mm",
        englishAdornment: "in",
        pairField: "true"
    },
    {
        label: "Head Type ",
        name: "headType",
        required: true,
        select: [
            { value: "2:1 S.E Head", label: "2:1 S.E Head" },
            { value: "Spherical", label: "Spherical" },
            { value: "Torispherical", label: "Torispherical" },
            { value: "Flat", label: "Flat" },
        ]
    },
    // {
    //     label: "Support Type ",
    //     name: "supportType",
    //     required: true,
    //     select: [
    //         { value: "Saddle Support", label: "Saddle Support" },
    //         { value: "Leg Support", label: "Leg Support" },
    //         { value: "Lifting Lug", label: "Lifting Lug" },
    //     ]
    // },
    {
        label: "Hydrotest Design ",
        name: "hydrotestDesignBasis",
        required: true,
        select: [
            { value: "UG-99b", label: "UG-99b" },

        ]
    },
    {
        label: "Hydrotest Pressure ",    //Calculated value
        name: "hydrotestPressure",
        endAdornment: "N/mm\xB2",
        englishAdornment: "psi"

    },
    {
        label: "Liquid Height ",
        name: "liquidHeight",
        required: true,
        type: "number",
        endAdornment: "m",
        englishAdornment: "ft"
    },
    {
        label: "Liquid Density ",
        name: "liquidDensity",
        required: true,
        type: "number",
        endAdornment: "Kg/m\xB3",
        englishAdornment: "lb/ft\xB3"
    },
    {
        label: "Insulation Thk ",
        name: "insulationThk",
        required: true,
        type: "number",
        endAdornment: "mm",
        englishAdornment: "in"
    },
    {
        label: "Insulation Density ",
        name: "insulationDensity",
        required: true,
        type: "number",
        endAdornment: "Kg/m\xB3",
        englishAdornment: "lb/ft\xB3"
    },
    {
        label: "PWHT ",
        name: "pwht",
        select: [
            { value: "YES", label: "YES" },
            { value: "NO", label: "NO" }
        ]
    },

]

export const materialData = [
    {
        label: "Shell ",
        materialFieldName: "shellMaterial",
        pairField: "true",
        select: [
            { value: "SA 516 70", label: "SA 516 70" },
            { value: "SA 516 60", label: "SA 516 60" },
            { value: "SA 36", label: "SA 36" },
            { value: "SA 240 304", label: "SA 240 304" },
            { value: "SA 240 304L", label: "SA 240 304L" },
            { value: "SA 240 316", label: "SA 240 316" },
            { value: "SA 240 316L", label: "SA 240 316L" }
        ],
        stressFieldName: "shellStress",
        curveFieldName: "shellCurve",
        requirementFieldName: "shellMaterialReq",
        requirementItems: [
            { value: "NOT", label: "NOT" },
            { value: "NACE MR 0175", label: "NACE MR 0175" },
        ]
    },
    {
        label: "Head",
        materialFieldName: "headMaterial",
        pairField: "true",
        select: [
            { value: "SA 516 70", label: "SA 516 70" },
            { value: "SA 516 60", label: "SA 516 60" },
            { value: "SA 36", label: "SA 36" },
            { value: "SA 240 304", label: "SA 240 304" },
            { value: "SA 240 304L", label: "SA 240 304L" },
            { value: "SA 240 316", label: "SA 240 316" },
            { value: "SA 240 316L", label: "SA 240 316L" }
        ],
        stressFieldName: "headStress",
        curveFieldName: "headCurve",
        requirementFieldName: "headMaterialReq",
        requirementItems: [
            { value: "NOT", label: "NOT" },
            { value: "NACE MR 0175", label: "NACE MR 0175" },
        ]

    },
    {
        label: "Nozzle Pipe ",
        materialFieldName: "nozzleMaterial",
        pairField: "true",
        select: [
            { value: "SA 516 70", label: "SA 516 70" },
            { value: "SA 516 60", label: "SA 516 60" },
            { value: "SA 36", label: "SA 36" },
            { value: "SA 240 304", label: "SA 240 304" },
            { value: "SA 240 304L", label: "SA 240 304L" },
            { value: "SA 240 316", label: "SA 240 316" },
            { value: "SA 240 316L", label: "SA 240 316L" },
            { value: "SA 106 B", label: "SA 106 B" },
            { value: "SA 333 6", label: "SA 333 6" },
            { value: "SA 312 TP304", label: "SA 312 TP304" },
            { value: "SA 312 TP316", label: "SA 312 TP316" },
            { value: "SA 312 TP316L", label: "SA 312 TP316L" },

        ],
        stressFieldName: "nozzleStress",
        curveFieldName: "nozzleCurve",
        requirementFieldName: "nozzleMaterialReq",
        requirementItems: [
            { value: "NOT", label: "NOT" },
            { value: "NACE MR 0175", label: "NACE MR 0175" },
        ]

    },
    {
        label: "Flange/Forging",
        materialFieldName: "flangeMaterial",
        pairField: "true",
        select: [
            { value: "SA 105", label: "SA 105" },
            { value: "SA 350 LF2", label: "SA 350 LF2" },
            { value: "SA 182 F304", label: "SA 182 F304" },
            { value: "SA 182 F304L", label: "SA 182 F304L" },
            { value: "SA 182 F316", label: "SA 182  F316" },
            { value: "SA 182 F316L", label: "SA 182 F316L" },

        ],
        stressFieldName: "flangeStress",
        curveFieldName: "flangeCurve",
        requirementFieldName: "flangeMaterialReq",
        requirementItems: [
            { value: "NOT", label: "NOT" },
            { value: "NACE MR 0175", label: "NACE MR 0175" },
        ]

    },
    {
        label: "RF Pad",
        materialFieldName: "rfPadMaterial",
        pairField: "true",
        select: [
            { value: "SA 516 70", label: "SA 516 70" },
            { value: "SA 516 60", label: "SA 516 60" },
            { value: "SA 36", label: "SA 36" },
            { value: "SA 240 304", label: "SA 240 304" },
            { value: "SA 240 304L", label: "SA 240 304L" },
            { value: "SA 240 316", label: "SA 240 316" },
            { value: "SA 240 316L", label: "SA 240 316L" }
        ],
        stressFieldName: "rfPadStress",
        curveFieldName: "rfPadCurve",
        requirementFieldName: "rfPadMaterialReq",
        requirementItems: [
            { value: "NOT", label: "NOT" },
            { value: "NACE MR 0175", label: "NACE MR 0175" },
        ]

    },
    {
        label: "Stud Bolt/Nut",
        materialFieldName: "studBoltMaterial",
        select: [
            { value: "SA 193-B7 / SA194-2H", label: "SA 193-B7 / SA194-2H" }

        ],
        stressFieldName: "studBoltStress",
        curveFieldName: "studBoltCurve",
        requirementFieldName: "studBoltMaterialReq",
        requirementItems: [
            { value: "NOT", label: "NOT" },
            { value: "NACE MR 0175", label: "NACE MR 0175" },
        ]

    },
    {
        label: "Gasket",
        materialFieldName: "gasketMaterial",
        select: [
            { value: "Spiral wound SS304 with Non Asbestos filler", label: "Spiral wound SS304 with Non Asbestos filler" }

        ],
        stressFieldName: "gasketStress",
        curveFieldName: "gasketCurve",
        requirementFieldName: "gasketMaterialReq",
        requirementItems: [
            { value: "Galvanized", label: "Galvanized" },
            { value: "NOT", label: "NOT" },
            { value: "NACE MR 0175", label: "NACE MR 0175" },
            { value: "PTFE Coated or Galvanised", label: "PTFE Coated or Galvanised" },
        ]
    },

]

//All select values ARE SA 516 70, SA 516 60, SA 36, SA 240 304, SA 240 304L, SA 240 316, SA 240 316L

//Stress col; shellStress, headStress, nozzleStress, flangeStress, rfPadStress, studBoltStress, gasketStress

//Curve: shellCurve, headCurve, nozzleCurve, flangeCurve, rfPadCurve, studBoltCurve, gasketCurve
